import {
    GET_SELECTED_DEVICE_ID_DATA, ERROR_SELECTED_DEVICE_ID_DATA, CLEAR_SELECTED_DEVICE_ID_DATA,
    GET_SELECTED_DEVICE_LOGIN,ERROR_SELECTED_DEVICE_LOGIN, UPDATE_DEVICE_DATA,
    GET_META_INFO_HISTORY_REQUEST, GET_META_INFO_HISTORY_SUCCESS, GET_META_INFO_HISTORY_FAIL
} from "./constants";
import { SUBMIT_SUCCESS, SUBMIT_FAIL } from './constants'

const initialState = {
    deviceID: null,
    devName: null,
    loading: true,
    error: '',
    metaInfo: [],
    deviceSettings: [],
    isError:false,
    result: false,
    heater_id:'',
    lastLogin:null,
    // Meta Info History State
    metaInfoHistory: [],
    metaInfoHistoryLoading: false,
    metaInfoHistoryError: null,
    lastEditor: null,
}

const deviceInfoReducer = function (state = initialState, action) {
    const { type, payload } = action;
    switch (type) {
        case GET_SELECTED_DEVICE_ID_DATA:
            global.heater_id = String(payload.metaInfo.heaterId || '');
            global.compressorModuler_id = String(payload.metaInfo.compressorModulerId || '')
            global.compressor_id = String(payload.metaInfo.compressorId || '')
            global.sim_id = String(payload.metaInfo.simId || '')
            global.phone_number = String(payload.metaInfo.phoneNumber || '')
            global.capacity = String(payload.metaInfo.capacity || '')
            global.battery_voltage = String(payload.metaInfo.batteryVoltage || '')
            global.imei_no = String(payload.metaInfo.imeiNo || '')
            global.device_name = String(payload.deviceName || '')
            global.Ota_version = String(payload.deviceSettings.OtaVersion || '')
            return {
                ...state,
                deviceID: payload.deviceID,
                devName: payload.deviceName,
                metaInfo: payload.metaInfo,
                deviceSettings:payload.deviceSettings,
                loading: false,
                isError:false,
                error: ''
            }
        case GET_SELECTED_DEVICE_LOGIN:
            return {
                ...state,
                lastLogin:payload.lastLogin,
                loading: false,
                isError:false,
                error: ''
            }
        case ERROR_SELECTED_DEVICE_LOGIN:
        case ERROR_SELECTED_DEVICE_ID_DATA:
            return {
                ...state,
                isError:true,
                error: payload,
                loading: false,
                metaInfo: [],
                deviceSettings: [],
                lastLogin:null
            }
            
        case CLEAR_SELECTED_DEVICE_ID_DATA:
            return initialState
            
        case UPDATE_DEVICE_DATA:
            // Create completely new object references to ensure React detects changes
            console.log('🔄 REDUCER: UPDATE_DEVICE_DATA triggered');
            console.log('🔍 Previous state.metaInfo:', state.metaInfo);
            console.log('🔍 payload.updatedMetaInfo:', payload.updatedMetaInfo);
            console.log('🔍 payload.deviceName:', payload.deviceName);
            
            const newMetaInfo = { 
                ...state.metaInfo, 
                ...payload.updatedMetaInfo 
            };
            const newDevName = payload.deviceName || state.devName;
            
            // CRITICAL: Check object reference change
            console.log('🔁 reducer: oldRef === newRef ?', state.metaInfo === newMetaInfo);
            console.log('✨ NEW metaInfo object created:', newMetaInfo);
            console.log('✨ NEW devName:', newDevName);
            console.log('🔗 Object reference changed:', newMetaInfo !== state.metaInfo);
            
            const newState = {
                ...state,
                metaInfo: newMetaInfo, // New object reference
                devName: newDevName,   // Updated device name
                result: true,          // Mark as successful
                loading: false,        // Ensure loading is false
                isError: false,        // Clear any errors
                error: ''              // Clear error message
            };
            
            console.log('🎯 FINAL NEW STATE:', newState);
            return newState;
            
        case SUBMIT_FAIL:
                return {
                    ...state,
                    result: false
                }
        case SUBMIT_SUCCESS:
                return {
                    ...state,
                    result: true
                }
        
        // Meta Info History Cases
        case GET_META_INFO_HISTORY_REQUEST:
            return {
                ...state,
                metaInfoHistoryLoading: true,
                metaInfoHistoryError: null
            }
        
        case GET_META_INFO_HISTORY_SUCCESS:
            return {
                ...state,
                metaInfoHistory: payload.history || payload, // Handle both old and new payload structure
                lastEditor: payload.lastEditor || null,
                metaInfoHistoryLoading: false,
                metaInfoHistoryError: null
            }
        
        case GET_META_INFO_HISTORY_FAIL:
            return {
                ...state,
                metaInfoHistory: [],
                lastEditor: null,
                metaInfoHistoryLoading: false,
                metaInfoHistoryError: payload.msg
            }
        
        default:
            return state;
    }
}

export default deviceInfoReducer;